import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Grid,
  Chip,
} from "@mui/material";

const CreationDetailModal = ({ open, onClose, creation }) => {
  const handleAddToCart = () => {
    const productIds = creation.products.map((p) => p.id);
    // Aquí conectas con tu lógica de carrito
    console.log("Agregar al carrito:", productIds);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>Creación de {creation.user_name}</DialogTitle>
      <DialogContent>
        <img
          src={creation.image_url}
          alt='Creación'
          style={{ width: "100%", borderRadius: 8, marginBottom: 16 }}
        />
        <Typography variant='subtitle1' gutterBottom>
          Productos utilizados:
        </Typography>
        <Grid container spacing={1}>
          {creation.products.map((product) => (
            <Grid item key={product.id}>
              <Chip label={product.name} color='primary' />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
        <Button onClick={handleAddToCart} variant='contained' color='secondary'>
          Agregar productos al carrito
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreationDetailModal;
